import { render, staticRenderFns } from "./PaymentTypeList.vue?vue&type=template&id=585e70f4&scoped=true"
import script from "./PaymentTypeList.vue?vue&type=script&lang=ts"
export * from "./PaymentTypeList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585e70f4",
  null
  
)

export default component.exports